import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { iconGray, white } from '../../../theme';

import styles from './Step.module.scss';

const Step = (props) => {
  const { step, isUnlocked, isTouched, isCurrent, goToStep, style } = props;
  const { t } = useTranslation();
  return (
    <div
      className={cx(styles.step, {
        [styles.unlocked]: isUnlocked,
        [styles.touched]: isTouched,
        [styles.current]: isCurrent,
      })}
      style={style}
      key={`${step.id}${step.n}`}
    >
      <div className={styles.stepIconContainer}>
        <div className={styles.stepIconWrapper}>
          <button
            type="button"
            className={styles.stepIcon}
            onClick={isUnlocked ? () => goToStep(step) : null}
            disabled={!isUnlocked}
          >
            {step.icon ? (
              React.cloneElement(step.icon, { color: isTouched ? white : iconGray })
            ) : (
              <Icon name={step.iconName} />
            )}
          </button>
        </div>
      </div>
      <Typography
        className={styles.stepText}
        dangerouslySetInnerHTML={{
          __html: t(step.label),
        }}
      />
    </div>
  );
};

Step.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.string.isRequired,
    n: PropTypes.number.isRequired,
    iconName: PropTypes.string.isRequired,
    icon: PropTypes.shape({}),
    label: PropTypes.string.isRequired,
  }).isRequired,
  isUnlocked: PropTypes.bool.isRequired,
  isTouched: PropTypes.bool.isRequired,
  isCurrent: PropTypes.bool.isRequired,
  goToStep: PropTypes.func,
  style: PropTypes.shape({}),
};

Step.defaultProps = {
  goToStep: () => {},
  style: {},
};

export default Step;
